export function isCombinedFormatted(value) {
    return 'combined' in value;
}
export function isAxisFormatted(value) {
    return 'x' in value && 'y' in value;
}
//# sourceMappingURL=types.js.map